import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'htmlReplace'})
export class HtmReplacePipe implements PipeTransform  {
    transform(value) {
        return value.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/pipe/htm-replace.pipe.ts